export const EmptyResults = Array.from({ length: 6 }).map((_, id) => {
  return (
    <div className="mb-4 w-full grow" key={id}>
      <div className="w-1/2 space-y-1 overflow-hidden">
        <div className="bg-twilight h-2 w-1/2 rounded-sm" />
        <div className="bg-twilight h-2 rounded-sm" />
      </div>
    </div>
  );
});
